import { Component, OnInit } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { Tabs } from "../../shared/tabs/tabs";
import { RouterModule } from "@angular/router";



@Component({
  selector: 'app-kibor',
  standalone: true,
  imports: [
    TranslatePipe,
    CommonModule,
    Tabs,
    RouterModule
],
  templateUrl: './kibor.html',
  styleUrl: './kibor.css',
})
export class Kibor  {
tabs = [
  { label: 'SETUP.KIBOR.QUARTERLY', route: 'partial' },
  { label: 'SETUP.KIBOR.BIANNUALLY', route: 'quarterly' },
];

}